import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {message, notification} from 'antd';
import {AxiosError, AxiosResponse} from 'axios';
import FILTERS from '../../common/filters.type';
import type {
  LIVE_BATTERIES,
  CONFIG,
  MAIN_FILTER,
  UPDATE_COLUMNS,
  BATTERY_DETAIL,
} from './liveBatteries.type';

import liveBatteriesServices from './liveBatteriesServices';

const initialState = {
  isLoading: false,

  config: {} as CONFIG,
  liveBatteriesList: {
    page_size: 10,
    page_number: 1,
    sort_by: 'asset_id',
    ascending: true,
    search: '',
    totalDataCount: 0,
    pageData: [] as LIVE_BATTERIES[],
  },
  batteryDetails: {} as BATTERY_DETAIL,
};

export const liveBatteriesConfig = createAsyncThunk(
  'liveBatteriesConfig',
  async (payload, thunkAPI) => {
    try {
      const data: AxiosResponse = await liveBatteriesServices.config();

      return data;
    } catch (error) {
      const result = error as AxiosError;

      return thunkAPI.rejectWithValue(result.message);
    }
  },
);
export const liveBatteriesColoumnUpdate = createAsyncThunk(
  'liveBatteriesColoumnUpdate',
  async (payload: UPDATE_COLUMNS, thunkAPI) => {
    try {
      const data: AxiosResponse = await liveBatteriesServices.liveBatteriesColoumnUpdate(payload);

      return data;
    } catch (error) {
      const result = error as AxiosError;

      return thunkAPI.rejectWithValue(result.message);
    }
  },
);
export const liveBatteries = createAsyncThunk(
  'liveBatteries',
  async (payload: {body: MAIN_FILTER; filters: FILTERS}, thunkAPI) => {
    try {
      const data: AxiosResponse = await liveBatteriesServices.liveBatteriesList(payload);

      return data;
    } catch (error) {
      const result = error as AxiosError;

      return thunkAPI.rejectWithValue(result.message);
    }
  },
);
export const liveBatteriesCSV = createAsyncThunk(
  'liveBatteriesCSV',
  async (payload: MAIN_FILTER, thunkAPI) => {
    try {
      const data: AxiosResponse = await liveBatteriesServices.liveBatteriesCSV(payload);

      return data;
    } catch (error) {
      const result = error as AxiosError;

      return thunkAPI.rejectWithValue(result.message);
    }
  },
);
export const battteryDetails = createAsyncThunk(
  'battteryDetails',
  async (payload: {asset_id: string}, thunkAPI) => {
    try {
      const data: AxiosResponse = await liveBatteriesServices.batteryDetails(payload);

      return data;
    } catch (error) {
      const result = error as AxiosError;

      return thunkAPI.rejectWithValue(result.message);
    }
  },
);
export const liveBatteriesSlice = createSlice({
  name: 'liveBatteriesSlice',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    pageNumberChange(state, action: PayloadAction<number>) {
      state.liveBatteriesList.page_number = action.payload;
    },
    pageSizeChange(state, action: PayloadAction<number>) {
      state.liveBatteriesList.page_number = 1;
      state.liveBatteriesList.page_size = action.payload;
    },
    searchBy(state, action: PayloadAction<string>) {
      state.liveBatteriesList.page_number = 1;
      state.liveBatteriesList.search = action.payload;
    },
    sortBy(state, action: PayloadAction<{ascending: boolean; sortBy: string}>) {
      state.liveBatteriesList.ascending = action.payload.ascending;
      state.liveBatteriesList.sort_by = action.payload.sortBy;
    },
    clearLiveBatteryFilter(state) {
      state.liveBatteriesList = initialState.liveBatteriesList;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(liveBatteriesConfig.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(liveBatteriesConfig.fulfilled, (state, action) => {
      state.isLoading = false;
      state.config = action.payload.data;
    });
    builder.addCase(liveBatteriesConfig.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(liveBatteriesColoumnUpdate.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(liveBatteriesColoumnUpdate.fulfilled, (state) => {
      state.isLoading = false;
      message.success('Updated Successfully');
    });
    builder.addCase(liveBatteriesColoumnUpdate.rejected, (state) => {
      state.isLoading = false;
      message.error('Error, Please try again');
    });
    builder.addCase(liveBatteries.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(liveBatteries.fulfilled, (state, action) => {
      state.isLoading = false;
      state.liveBatteriesList = action.payload.data;
    });
    builder.addCase(liveBatteries.rejected, (state, action) => {
      state.isLoading = false;
      message.error(`${action.payload}`);
    });
    builder.addCase(liveBatteriesCSV.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(liveBatteriesCSV.fulfilled, (state) => {
      //state.csv = action.payload.data;    // Direct handled in download CSV Component
      state.isLoading = false;
    });
    builder.addCase(liveBatteriesCSV.rejected, (state) => {
      state.isLoading = false;
      message.error('Error , Please try again');
    });
    builder.addCase(battteryDetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(battteryDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.batteryDetails = action.payload.data;
    });
    builder.addCase(battteryDetails.rejected, (state, action) => {
      state.isLoading = false;
      notification.error({message: `${action.payload}`});
    });
  },
});
export const {pageNumberChange, pageSizeChange, searchBy, sortBy, clearLiveBatteryFilter} =
  liveBatteriesSlice.actions;

export default liveBatteriesSlice.reducer;
